import angular from 'angular';
import alertComponent from './alert.component';
import './alert.scss';

export default angular.module('common.alert', [])
  .component('alert', alertComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/alert/alert.module.js